import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
	PUT_LOADING: type('[AncillariesWithMiles] loading'),
	PUT_ANCILLARY_TO_PAY: type('[AncillariesWithMiles] put ancillaryToPay'),
	PUT_ADDED_ANCILLARY: type('[AncillariesWithMiles] put added ancillary'),
	REMOVE_ADDED_ANCILLARY: type('[AncillariesWithMiles] remove added ancillary'),
	PUT_FLIGHT_MILES_DISCOUNT: type('[AncillariesWithMiles] put flight miles discount'),
	PUT_PROCESS_ANCILLARY: type('[AncillariesWithMiles] put processAncillary'),
	PUT_ANCILLARY_TOTAl_TO_PAY: type('[AncillariesWithMiles] put ancillaryTotalToPay'),
	PUT_ORIGINAL_BOOKING_COST: type('[AncillariesWithMiles] put originalBookingCost'), // temporary until refactor - move to different action type
	PUT_DISCOUNTED_BOOKING_COST: type('[AncillariesWithMiles] put discountedBookingCost'), // temporary until refactor - move to different action type
	RESET: type('[AncillariesWithMiles] Reset')
};

export class PutLoadingAction implements Action {
	type = ActionTypes.PUT_LOADING;

	/**
	 *Creates an instance of PutLoadingAction.
	 * @param {*} [payload]
	 * @memberof PutLoadingAction
	 */
	constructor(public payload: any) { }
}

export class PutAncillaryToPayAction implements Action {
	type = ActionTypes.PUT_ANCILLARY_TO_PAY;

	/**
	 *Creates an instance of PutAncillaryToPayAction.
	 * @param {*} [payload]
	 * @memberof PutAncillaryToPayAction
	 */
	constructor(public payload: any) { }
}

export class PutAddedAncillaryAction implements Action {
	type = ActionTypes.PUT_ADDED_ANCILLARY;

	/**
	 *Creates an instance of PutAddedAncillaryAction.
	 * @param {*} [payload]
	 * @memberof PutAddedAncillaryAction
	 */
	constructor(public payload: any) { }
}

export class RemoveAddedAncillaryAction implements Action {
	type = ActionTypes.REMOVE_ADDED_ANCILLARY;

	/**
	 *Creates an instance of RemoveAddedAncillaryAction.
	 * @param {*} [payload]
	 * @memberof RemoveAddedAncillaryAction
	 */
	constructor(public payload: string) { }
}

export class PutFlightMilesDiscountAction implements Action {
	type = ActionTypes.PUT_FLIGHT_MILES_DISCOUNT;

	/**
	 *Creates an instance of PutFlightMilesDiscountAction.
	 * @param {*} [payload]
	 * @memberof PutFlightMilesDiscountAction
	 */
	constructor(public payload: any) { }
}

export class PutProcessAncillary implements Action {
	type = ActionTypes.PUT_PROCESS_ANCILLARY;

	/**
	 *Creates an instance of PutProcessAncillary.
	 * @param {*} [payload]
	 * @memberof PutProcessAncillary
	 */
	constructor(public payload: any) { }
}

export class PutAncillaryTotalToPayAction implements Action {
	type = ActionTypes.PUT_ANCILLARY_TOTAl_TO_PAY;

	/**
	 *Creates an instance of PutAncillaryMilesToPayAction.
	 * @param {*} [payload]
	 * @memberof PutAncillaryTotalToPayAction
	 */
	constructor(public payload: any) { }
}

export class PutOriginalBookingCost implements Action {
	type = ActionTypes.PUT_ORIGINAL_BOOKING_COST;

	/**
	 *Creates an instance of PutOriginalBookingCost.
	 * @param {*} [payload]
	 * @memberof PutOriginalBookingCost
	 */
	constructor(public payload: any) { }
}

export class PutDiscountedBookingCost implements Action {
	type = ActionTypes.PUT_DISCOUNTED_BOOKING_COST;

	/**
	 *Creates an instance of PutDiscountedBookingCost.
	 * @param {*} [payload]
	 * @memberof PutDiscountedBookingCost
	 */
	constructor(public payload: any) { }
}


export class ResetAction implements Action {
	type = ActionTypes.RESET;

	constructor(public payload?) { }
}

export type Actions = PutLoadingAction | PutAncillaryToPayAction | PutAddedAncillaryAction | RemoveAddedAncillaryAction| PutFlightMilesDiscountAction | PutProcessAncillary | PutAncillaryTotalToPayAction | PutOriginalBookingCost | PutDiscountedBookingCost | ResetAction ;
